import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-profile-form',
  templateUrl: './company-profile-form.component.html',
  styleUrls: ['./company-profile-form.component.css']
})
export class CompanyProfileFormComponent implements OnInit {
  title="Add Company Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ultilities/company-profile/company-profile-form/company-profile-form.component.ts